<template>
<side-bar :background-color="sidebarBackground" short-title="Church" title="Church">
    <template slot="links">
        <sidebar-item :link="{name: 'Dashboard', icon: 'ni ni-tv-2 text-primary', path: '/dashboard'
            }" />
        <sidebar-item :link="{name: 'Churches', icon: 'ni ni-building text-blue', path: '/church'}" />
         <sidebar-item :link="{name: 'Staff', icon: 'fa fa-users text-blue', path: '/Studarchive'}" />
        <sidebar-item :link="{name: 'Message', icon: 'ni ni-email-83 text-blue', path: '/subjectsetup'}" />
       
    </template>
</side-bar>
</template>
<script>
export default {
     data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
}
</script>